import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://admin.granasialife.com/api/', 
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

export const setCsrfToken = (csrfToken) => {
  instance.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
  
};



export default instance;
